module.exports = __webpack_public_path__ + "static/img/IMG_3613.b2bbf682.jpg";